import type { ClientError } from 'graphql-request';
import type { GraphQLError } from 'graphql/index';
import ErrorMessage from 'src/components/error-message';
import MetaTags from 'src/components/meta-tags';
import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';

interface PrisjaktGraphqlError extends GraphQLError {
  status?: number;
}

export const ErrorPage = ({ error }: { error: Error }) => {
  const { t } = useContext(AppContext);
  const firstError = (error as ClientError).response?.errors?.[0];
  let status = (error as any).status ?? 500;

  if (firstError) {
    status = (firstError as PrisjaktGraphqlError).status ?? 500;
  }

  return (
    <>
      <ErrorMessage status={status} />
      <MetaTags
        metaTags={{
          title: `${t('errors', 'internal.unknown')} (${status})`,
        }}
      />
    </>
  );
};
